import React from 'react'
import {
  OfferLineDataTestProps,
  OfferLineItem,
  OfferLineUiProps,
} from 'src/shared/components/offer-price/offer-line-item/offer-line-item'
import { OrderTotalWrapper } from 'src/shared/components/offer-price/order-total/ui/order-total-wrapper'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'

export interface OrderTotalProps extends OfferLineDataTestProps {
  total?: number
  dueToday?: number
  isRecurrentPayment?: boolean
  offerLineUiProps: OfferLineUiProps
  currency: string
  locale: string
}

export const OrderTotal = ({
  total,
  dueToday,
  isRecurrentPayment,
  currency,
  locale,

  offerLineUiProps,

  dataTestIdName,
  dataTestIdPrice,
  dataTestIdCurrency,
  dataTestIdTax,
}: OrderTotalProps) => {
  const { t } = useTypedTranslation(['common'])

  const label = isRecurrentPayment
    ? t('components.offer_price.total_due_today')
    : t('components.offer_price.total')
  const amount = isRecurrentPayment ? dueToday : total

  return (
    <OrderTotalWrapper>
      {typeof amount !== 'undefined' && (
        <OfferLineItem
          label={label}
          amount={amount}
          currency={currency}
          locale={locale}
          dataTestIdName={dataTestIdName}
          dataTestIdPrice={dataTestIdPrice}
          dataTestIdCurrency={dataTestIdCurrency}
          dataTestIdTax={dataTestIdTax}
          shouldDisplayCurrencyBadge
          {...offerLineUiProps}
        />
      )}
    </OrderTotalWrapper>
  )
}
